<template>
    <div>
        <div><strong>Filters</strong></div>
        <v-card class="mb-4 d-flex">
            <!-- room types dropdown -->
            <v-select
                class="pr-2 pl-2 min-width-50-pct"
                :items="roomTypeOptions"
                v-model="selectedRoomTypeOptions"
                label="Room Types"
                item-text="name"
                item-value="hotelRoomKey"
                multiple
                chips
                small-chips
                deletable-chips
                >
            </v-select>
                    
            <!-- rate types -->
            <v-select
                class="pr-2 pl-2 min-width-50-pct"
                :items="rateTypeOptions"
                v-model="selectedRateTypeOptions"
                label="Rate Types"
                item-text="name"
                item-value="rateTypeKey"
                multiple
                chips
                small-chips
                deletable-chips
                >
            </v-select>
        </v-card>
                        
        <div><strong>View Options</strong></div>
        <v-card class="mb-4 d-flex">
            <!-- rate view options -->
            <v-select
                class="pr-2 pl-2 min-width-50-pct"
                :items="rateViewOptions"
                v-model="selectedRateViewOptions"
                label="Rate Options"
                item-text="text"
                item-value="value"
                multiple
                chips
                small-chips
                deletable-chips>
            </v-select>
                
            <!-- restriction view options -->
            <v-select
                class="pr-2 pl-2 min-width-50-pct"
                :items="restrictionViewOptions"
                v-model="selectedRestrictionViewOptions"
                label="Restriction Options"
                item-text="text"
                item-value="value"
                multiple
                chips
                small-chips
                deletable-chips>
            </v-select>
        </v-card>

        <div><strong>Single/Multiple View</strong></div>
        <v-card class="mb-4 d-flex">
            <v-select
            class="pr-2 pl-2 min-width-50-pct"
            :items="monthViewOptions"
            v-model="numMonthsSelected"
            label="Number of Months"
            />
    
            <v-select v-if="numMonthsSelected > 1"
            class="pr-2 pl-2 min-width-50-pct"
            :items="availabilityRowDisplayOptions"
            v-model="availabilityRowDisplay"
            label="Display"
            item-text="text"
            item-value="value"
            />
        </v-card>    

    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'hotel-planner-table-controls',
    props: {
        'tableViewOptions': Object,
        'selectedTableViewOptions': Object,
        'hotelKey': String
    },

    data() {

        return {
            localSelectedTableViewOptions: this.selectedTableViewOptions,

            numMonthsSelected: 1,
            
            monthViewOptions: [
                1,3,6,12
            ],

            availabilityRowDisplay: 'quantity',

            availabilityRowDisplayOptions: [
                { text: 'Availability', value: 'quantity' },
                { text: 'Minimum Rate', value: 'minRate' },
            ],
                        
            selectedRoomTypeOptions: [],
            selectedRateTypeOptions: [],
            selectedRateViewOptions: [],
            selectedRestrictionViewOptions: [],
        }
    },

    methods: {
        saveSelectedTableViewOptions() {            
            axios.post('api/hotel-planner/remember-view-options/' + this.hotelKey , this.localSelectedTableViewOptions);
       },

       initSelectedRoomTypeOptions() {
           this.selectedRoomTypeOptions = this.localSelectedTableViewOptions['roomTypeOptions'] || [];
       },

       initSelectedRateTypeOptions() {
           this.selectedRateTypeOptions = this.localSelectedTableViewOptions['rateTypeOptions'] || [];
       },

       initSelectedRateViewOptions() {
           let rateViewOptions = [
               'showExtraBedRate',
               'showExtraChildBedRate',
               'showExtraOldChildBedRate',
               'showExtraCotRate',
               'showSingleRate'
           ];

           rateViewOptions.forEach((rateViewOption) => {
               if (this.localSelectedTableViewOptions[rateViewOption]) {
                   this.selectedRateViewOptions.push(rateViewOption);
               }
           });
       },
       
       initSelectedRestrictionViewOptions() {
           let restrictionViewOptions = [
               'showMinimumStay',
               'showMaximumStay',
               'showNoCheckInDays',
               'showNoCheckOutDays'
           ];

           restrictionViewOptions.forEach((restrictionViewOption) => {
               if (this.localSelectedTableViewOptions[restrictionViewOption]) {
                   this.selectedRestrictionViewOptions.push(restrictionViewOption);
               }
           });
       }
    },

    mounted() {
        this.initSelectedRateTypeOptions();
        this.initSelectedRoomTypeOptions();
        this.initSelectedRateViewOptions();
        this.initSelectedRestrictionViewOptions();
    },
    

    computed: {
        roomTypeOptions() {
          return this.tableViewOptions.roomTypeOptions || [];
        },
      
        rateTypeOptions() {
          return this.tableViewOptions.rateTypeOptions || [];
        },

        rateViewOptions() {
          return this.tableViewOptions.rateViewOptions || [];
        },

        restrictionViewOptions() {
          return this.tableViewOptions.restrictionViewOptions || [];
        }
    },

    watch: 
    {
        selectedRoomTypeOptions(newSelectedRoomTypeOptions) {
            this.localSelectedTableViewOptions['roomTypeOptions'] = newSelectedRoomTypeOptions;
            this.saveSelectedTableViewOptions();
        },

        selectedRateTypeOptions(newSelectedRateTypeOptions) {
            this.localSelectedTableViewOptions['rateTypeOptions'] = newSelectedRateTypeOptions;
            this.saveSelectedTableViewOptions();
        },

        selectedRestrictionViewOptions(newSelectedRestrictionViewOptions) {
            this.restrictionViewOptions.forEach((option) => {
                this.localSelectedTableViewOptions[option.value] = newSelectedRestrictionViewOptions.includes(option.value);
            });

            this.saveSelectedTableViewOptions();
        },

        selectedRateViewOptions(newSelectedRateViewOptions) {
            this.rateViewOptions.forEach((option) => {
                this.localSelectedTableViewOptions[option.value] = newSelectedRateViewOptions.includes(option.value);
            });

            this.saveSelectedTableViewOptions();
        },

        numMonthsSelected(newNumMonthsSelected) {
            this.$emit('updateNumMonths', newNumMonthsSelected);
        },

        availabilityRowDisplay(newAvailabilityRowDisplay) {
            this.$emit('updateAvailabilityRowDisplay', newAvailabilityRowDisplay);
        }
    },
}
</script>

<style>
    .min-width-50-pct {
        min-width: 50%;
    }
</style>

